import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "space-y-4" }
const _hoisted_2 = { class: "max-w-120 text-xl font-semibold text-center" }
const _hoisted_3 = { class: "flex items-center border border-dark-gray-800 border-opacity-20 rounded-lg pl-3 pr-1 py-2 space-x-2 w-120 focus-within:border-opacity-50" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "w-120" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "w-120 table-headers-medium" }
const _hoisted_8 = { class: "px-6 flex mt-2 rounded text-dark-gray-800 text-opacity-50" }
const _hoisted_9 = { class: "flex flex-1" }
const _hoisted_10 = { class: "mx-auto" }
const _hoisted_11 = { class: "flex flex-1" }
const _hoisted_12 = { class: "mx-auto" }
const _hoisted_13 = {
  key: 0,
  class: "rounded flex py-4 px-6 my-4 bg-feed-600 bg-opacity-60 border-2 border-opacity-10 rounded-lg"
}
const _hoisted_14 = { class: "flex flex-1 my-auto break-words" }
const _hoisted_15 = { class: "mx-auto" }
const _hoisted_16 = { class: "flex flex-1 my-auto break-words" }
const _hoisted_17 = { class: "mx-auto w-32" }
const _hoisted_18 = { class: "flex w-12 my-auto" }
const _hoisted_19 = { class: "flex flex-1 my-auto break-words" }
const _hoisted_20 = { class: "mx-auto" }
const _hoisted_21 = { class: "flex flex-1 my-auto break-words" }
const _hoisted_22 = { class: "mx-auto" }
const _hoisted_23 = { class: "flex w-12 my-auto" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "flex space-x-4" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = { class: "m-auto pr-2" }
const _hoisted_28 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_CustomSelect = _resolveComponent("CustomSelect")!
  const _component_SimpleInput = _resolveComponent("SimpleInput")!
  const _component_FeedDatePicker = _resolveComponent("FeedDatePicker")!
  const _component_DeleteButton = _resolveComponent("DeleteButton")!
  const _component_DeleteMixConfirmationModal = _resolveComponent("DeleteMixConfirmationModal")!
  const _component_AddButton = _resolveComponent("AddButton")!
  const _component_MixFarmsModal = _resolveComponent("MixFarmsModal")!
  const _component_MixRawMaterialsModal = _resolveComponent("MixRawMaterialsModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('views.feed.mixes.editMixModal.header')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Icon, {
        class: "h-3.5 w-3.5 flex-shrink-0 opacity-50",
        src: _ctx.IconSource.Edit
      }, null, 8, ["src"]),
      _withDirectives(_createElementVNode("input", {
        ref: "nameInput",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editedName) = $event)),
        type: "text",
        class: "flex-1 outline-none bg-transparent text-sm min-w-0 text-gray-400 focus:text-gray-800 transition-colors"
      }, null, 512), [
        [_vModelText, _ctx.editedName]
      ]),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass([{ 'opacity-25 cursor-default': !_ctx.editedNameChanged || _ctx.isSavingName, 'hover:bg-gray-100': _ctx.editedNameChanged && !_ctx.isSavingName }, "p-1.5 rounded transition-colors flex-shrink-0"]),
        disabled: !_ctx.editedNameChanged || _ctx.isSavingName,
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSaveNameClicked && _ctx.onSaveNameClicked(...args)))
      }, [
        _createVNode(_component_Icon, {
          class: "h-4 w-4",
          src: _ctx.IconSource.Check
        }, null, 8, ["src"])
      ], 10, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_CustomSelect, {
        value: _ctx.mix.category?.id ?? '',
        prepend: _ctx.$t('views.feed.mixes.table.headings.category'),
        label: "",
        items: _ctx.mixCategories,
        "item-text": "name",
        "item-value": "id",
        "show-required-indication": false,
        "allow-empty": true,
        "onUpdate:value": _ctx.onCategoryChanged
      }, null, 8, ["value", "prepend", "items", "onUpdate:value"])
    ]),
    (_ctx.loggedInUserCanReadFeedPrices)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("table", _hoisted_7, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_8, [
                _createElementVNode("th", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.priceHeader), 1)
                ]),
                _createElementVNode("th", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('views.feed.mixes.editMixModal.table.headers.validFrom')), 1)
                ]),
                _cache[7] || (_cache[7] = _createElementVNode("th", { class: "flex w-12" }, null, -1))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_ctx.mix.type.id === 2)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                    _createElementVNode("td", _hoisted_14, [
                      _createElementVNode("span", _hoisted_15, [
                        _createVNode(_component_SimpleInput, {
                          value: _ctx.priceToAdd.price,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.priceToAdd.price) = $event)),
                          class: "w-20",
                          type: "number",
                          placeholder: _ctx.$t('views.feed.mixes.editMixModal.table.newPricePlaceholder')
                        }, null, 8, ["value", "placeholder"])
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, [
                        _createVNode(_component_FeedDatePicker, {
                          value: _ctx.priceToAdd.valid_from,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.priceToAdd.valid_from) = $event)),
                          placeholder: _ctx.$t('views.feed.mixes.editMixModal.table.newValidFromPlaceholder'),
                          disabled: false
                        }, null, 8, ["value", "placeholder"])
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_18, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass([{ 'opacity-25 cursor-default': !_ctx.validPriceToAdd, 'bg-primary-800 text-white rounded font-medium': _ctx.validPriceToAdd }, "mx-auto px-2 py-1"]),
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onAddPriceClicked && _ctx.onAddPriceClicked(...args)))
                      }, _toDisplayString(_ctx.$t('views.feed.mixes.editMixModal.table.addPriceButtonLabel')), 3)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prices, (price, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: index,
                  class: "rounded flex py-4 px-6 my-4 odd:bg-dark-gray-100 border-2 border-opacity-10 rounded-lg"
                }, [
                  _createElementVNode("td", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$n(price.price, 'price')), 1)
                  ]),
                  _createElementVNode("td", _hoisted_21, [
                    _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$d(new Date(price.valid_from), 'short')), 1)
                  ]),
                  _createElementVNode("td", _hoisted_23, [
                    (_ctx.mix.type.id === 2 && _ctx.mix.prices && _ctx.mix.prices.length > 1)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "mx-auto",
                          onClick: ($event: any) => (_ctx.onDeletePriceClicked(price))
                        }, [
                          _createVNode(_component_Icon, {
                            class: "w-6",
                            src: _ctx.IconSource.Delete
                          }, null, 8, ["src"])
                        ], 8, _hoisted_24))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_25, [
      _createVNode(_component_DeleteMixConfirmationModal, {
        mix: _ctx.computedValue,
        onSubmit: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('submit')))
      }, {
        default: _withCtx((scope) => [
          _createVNode(_component_DeleteButton, {
            onClick: scope.open
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('views.feed.mixes.deleteMixModal.deleteButtonLabel')), 1)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _: 1
      }, 8, ["mix"]),
      _createElementVNode("button", {
        type: "button",
        disabled: _ctx.isDeactivating,
        class: _normalizeClass([_ctx.isDeactivating ? 'bg-gray-300 text-white cursor-default' : 'bg-orange-400 text-orange-500 bg-opacity-25 hover:bg-opacity-35 cursor-pointer', "rounded-lg py-2 px-3 flex transition-colors"]),
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onToggleMixActiveClicked && _ctx.onToggleMixActiveClicked(...args)))
      }, [
        _createElementVNode("span", _hoisted_27, [
          _createVNode(_component_Icon, {
            class: "w-6",
            src: _ctx.mix.is_active ? _ctx.IconSource.Archive : _ctx.IconSource.Unarchive,
            style: _normalizeStyle(_ctx.isDeactivating
                            ? 'filter: brightness(0) invert(1) opacity(0.6)'
                            : 'filter: brightness(0) saturate(100%) invert(54%) sepia(91%) saturate(736%) hue-rotate(344deg) brightness(103%) contrast(101%)'
                        )
          }, null, 8, ["src", "style"])
        ]),
        _createElementVNode("span", null, _toDisplayString(_ctx.mix.is_active ? _ctx.$t('views.feed.mixes.editMixModal.deactivateButtonLabel') : _ctx.$t('views.feed.mixes.editMixModal.activateButtonLabel')), 1)
      ], 10, _hoisted_26),
      _createElementVNode("div", null, [
        _createVNode(_component_MixFarmsModal, { mix: _ctx.mix }, {
          default: _withCtx((scope) => [
            _createVNode(_component_AddButton, {
              onClick: scope.open
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('views.feed.mixes.editMixModal.mixFarms.mixFarmsButtonLabel')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }, 8, ["mix"])
      ]),
      (_ctx.showMixMaterials)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createVNode(_component_MixRawMaterialsModal, { mix: _ctx.mix }, {
              default: _withCtx((scope) => [
                _createVNode(_component_AddButton, {
                  onClick: scope.open
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('views.feed.mixes.editMixModal.mixRawMaterials.mixRawMaterialsButtonLabel')), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            }, 8, ["mix"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}